import { HisBaseGlobalsService } from './../../../core/service/base/his-base-globals.service';
import { HisDynamicFieldBase } from '../../model/field-base';
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisDynamicFieldConfig } from '../../model/formfield';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';

@Component( {
    template: `
        <his-plam [label]="options.label" [helptext]="options.helptext">
            <input #content
                [hisDdKey]="options.ddKey"
                [formControl]="formControl"
                pInputText>
                <font color="red">
                    <strong> This Type of input is not ready yet </strong>
                </font>
        </his-plam>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class InputNotImplementedComponent extends HisDynamicFieldBase<string> implements OnInit {

    height: number;
    options: HisDynamicFieldConfig;

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);
        const hbgs = inject(HisBaseGlobalsService);

        super( injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs );
        this.options = injectedData.options;
    }

    updateConfiguration( entireFormConfig: HisDynamicFieldConfig ) {
    }

    ngOnInit() {
        super.initFormControl( null );
    }

    getControlValue(): any {
        return this.formControl.value;
    }
}
